import axios from "axios";
import React, { useState, useEffect } from "react";
import CreaInfraestructura from "./Equipos/CreaModals/CreaInfraestructura";
import Cookies from "universal-cookie";

function Titulo2SeccionC(props) {
  const cookies = new Cookies();
  const [list, setList] = useState([]);

  const obtenerInfraestructura = () => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerInfraestructuraPorSolicitudId?SolicitudId=" +
        props.idSolicitud,
    })
      .then((response) => {
        setList(response.data || []);
      })
      .catch((error) => {
        console.error("Error al obtener infraestructura:", error);
      });
  };

  useEffect(() => {
    if (props.idSolicitud) {
      obtenerInfraestructura();
    }
  }, [props.idSolicitud]);

  // 🔹 callback desde el modal
  const onInfraestructuraCreada = () => {
    obtenerInfraestructura();
  };

  const mostrarAcciones =
    cookies.get("tipo_Usuario") == 2 &&
    window.location.href.includes("ProcesoAutoevaluacion");

  return (
    <div className="container-fluid">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            2.1 Complete la siguiente información para cada una de las sedes
          </h6>
        </div>

        <div className="card-body">
          {mostrarAcciones && (
            <CreaInfraestructura
              idSolicitud={props.idSolicitud}
              onInfraestructuraCreada={onInfraestructuraCreada}
            />
          )}

          <hr />

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Sede</th>
                  <th>Fecha inicial</th>
                  <th>Novedad</th>
                  <th>Fecha inspección</th>
                  <th>Cumple normas</th>
                  <th>Reforzamiento</th>
                  <th>SolicitudId</th>
                </tr>
              </thead>
              <tbody>
                {list.length > 0 ? (
                  list.map((item) => (
                    <tr key={item.id}>
                      <td>{item.sede}</td>
                      <td>{item.fecha_Inicial}</td>
                      <td>{item.novedad}</td>
                      <td>{item.fecha_Inspeccion}</td>
                      <td>{item.cumplimiento_Normas}</td>
                      <td>{item.reforzamiento}</td>
                      <td>{item.solicitudId}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No hay registros
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Titulo2SeccionC;
